import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import _ from "lodash";
import { Divider, Container } from "semantic-ui-react";
import ReactHtmlParser, { convertNodeToElement } from "react-html-parser";
import { patientHistoric } from "../../actions/auth";
import Sample from "../tables/Sample";
import TablesContainer from "../tables/TablesContainer";

class Results extends Component {
  uniqES6 = arrArg => {
    return arrArg.filter((elem, pos, arr) => {
      return arr.indexOf(elem) === pos;
    });
  };

  buildResultsWithComments() {
    const {
      results,
      results_comments,
      results_gram,
      results_germ,
      results_anti
    } = this.props.order;

    if (!results || results.length === 0) return [];

    // Agrupar comentarios por codigo_examen
    const comentariosMap = {};
    results_comments.forEach((comentario) => {
      const codigo = comentario.Examen || 'Sin_codigo';

      if(!comentariosMap[codigo]){
        comentariosMap[codigo] = [];
      }
      comentariosMap[codigo].push({
        posicion: comentario.posicion,
        HTML: comentario.HTML
      });

      Object.keys(comentariosMap).forEach((codigo) => {
        comentariosMap[codigo].sort((a,b) => a.posicion - b.posicion)
      })
      //comentariosMap[comentario.Examen] = comentario.HTML;
    });

    // Agrupar resultados por sección y luego por examen
    const secciones = _.groupBy(results, "nombre_seccion");

    const agrupados = Object.entries(secciones).map(
      ([nombre_seccion, resultadosDeSeccion]) => {
        const examenesPorCodigo = _.groupBy(resultadosDeSeccion, "codigo_examen");

        const examenes = Object.entries(examenesPorCodigo).map(
          ([codigo_examen, examResults]) => {
            const comentarioHTML = comentariosMap[codigo_examen] || null;

           
            // Obtener muestras asociadas al examen
            const muestras = examResults.map(r => r.nro_muestra).filter(Boolean);
            const muestrasUnicas = _.uniq(muestras);
            
            const gram = results_gram.filter(
              g => g.codigo_examen === codigo_examen
            );
            const germ = results_germ.filter(
              g => g.codigo_examen === codigo_examen
            );
            const anti = results_anti.filter(
              g => g.codigo_examen === codigo_examen
            );

            const germenes = results_germ
              .filter(g => g.codigo_examen === codigo_examen)
              .map(germ => {
                // Buscar antibióticos asociados a este germen
                const antibioticos = results_anti.filter(a =>
                  a.codigo_examen === germ.codigo_examen &&
                  a.nro_muestra === germ.nro_muestra &&
                  a.id_anti === germ.id_germen
                );
                
                return {
                  ...germ,
                  antibioticos
                };
              });

            //console.log('Microbiologia examen:', codigo_examen, { gram, germ, anti });

            return {
              codigo_examen,
              nombre_examen: examResults[0].nombre_examen,
              resultados: examResults,
              comentarioHTML,
              /*microbiologia: { // se comenta porque no se visualiza aparte
                gram,
                germ,
                anti,
                germenes
              }*/
            };
          }
        );

        return {
          nombre_seccion,
          examenes
        };
      }
    );

    return agrupados;
}

  commentsTransform(node, index) {
  if (
    (node.type === "tag" && node.name === "html") ||
    node.name === "body"
  ) {
    node.name = "span";
    return convertNodeToElement(node, index, this.commentsTransform.bind(this));
  }

  if (node.type === "tag" && node.name === "head") return null;

  if (node.type === "tag" && node.name === "ul") {
    node.name = "span";
    return convertNodeToElement(node, index, this.commentsTransform.bind(this));
  }

  if (node.type === "tag" && node.name === "img") {
    return (
      <a target="_blank" key={index} href={node.attribs.src}>
        Haga click para ver la imagen
      </a>
    );
  }

  if (node.type === "tag" && node.name === "p") {
    let fixed = false;
    node.children.forEach(c => {
      if (c.name === "font" && c.children.length === 1) {
        if (/^\s*$/.test(c.children[0].data)) {
          fixed = true;
        }
      }
    });
    if (fixed) return null;
  }

  if (node.type === "text") {
    node.data = node.data
      .replace(/Ã³/g, "ó")
      .replace(/Ã±/g, "ñ")
      .replace(/Ã¡/g, "á")
      .replace(/Ãº/g, "ú")
      .replace(/Ã©/g, "é")
      .replace(/Ã/g, "í")
      .replace(/âˆšâ‰¥/g, "ó")
      .replace(/âˆšÂ±/g, "ñ")
      .replace(/âˆšÂ°/g, "á")
      .replace(/âˆšâˆ«/g, "ú")
      .replace(/âˆšÂ©/g, "é")
      .replace(/âˆšâ‰\s/g, "í")
      .replace(/\r?\n|\r/g, "");
  }
}

  render() {
    const muestras = [];
    let showMicro = false;
    let showComments = false;
    let showResults = false;
    let numMuestraGram = 0,
      numMuestraGerm = 0,
      numMuestraAnti = 0;
    let maxMunMuestraGram = 0,
      maxMunMuestraGerm = 0,
      maxMunMuestraAnti = 0;
    const { goToRef } = this.props;
    const { results } = this.props.order;
    if (this.props.order.results_comments.length > 0) {
      showComments = true;
    } else {
      showComments = false;
    }

    if (results.length > 0) {
      showResults = true;
    } else {
      showResults = false;
    }

    if (this.props.order.results_gram.length > 0) {
      numMuestraGram = this.props.order.results_gram.map(e => e.nro_muestra);
      maxMunMuestraGram = Math.max(...numMuestraGram);
    }
    if (this.props.order.results_germ.length > 0) {
      numMuestraGerm = this.props.order.results_germ.map(e => e.nro_muestra);
      maxMunMuestraGerm = Math.max(...numMuestraGerm);
    }
    if (this.props.order.results_anti.length > 0) {
      numMuestraAnti = this.props.order.results_anti.map(e => e.nro_muestra);
      maxMunMuestraAnti = Math.max(...numMuestraAnti);
    }

    const maxNroMuestras = Math.max(
      maxMunMuestraGram,
      maxMunMuestraGerm,
      maxMunMuestraAnti
    );

    for (let index = 0; index < maxNroMuestras; index++) {
      const tempObj = {};
      tempObj.gram = this.props.order.results_gram.filter(
        e => e.nro_muestra === index + 1
      );
      
      tempObj.germ = this.props.order.results_germ.filter(
        e => e.nro_muestra === index + 1
      );
      
      tempObj.anti = this.props.order.results_anti.filter(
        e => e.nro_muestra === index + 1
      );
      muestras.push(tempObj);
    }

    /*console.log('RESULTS_COMMENT',this.props.order)
    const comentarioAnti = this.props.order.results_comments.filter(
      c => Number(c.posicion) > 200 //quiero buscar el id_germen y no el 100
    )
    console.log('COMMENT',comentarioAnti)*/
    const tablas = muestras.map((muestra, index) => {
      return (
        <Sample
          key={index}
          muestra={muestra}
          numMuestra={index + 1}
          maxNroMuestras={maxNroMuestras}
          orderDate={this.props.order.date}
          comentarioAnti={this.props.order.results_comments}
        />
      );
    });

    const groupedSections = this.buildResultsWithComments();

    const sections = groupedSections.map((section, idx) => (
      <div key={idx}>
        <div style={styles.segment}>{section.nombre_seccion}</div>
        {section.examenes.map((examen, i) => (
          <div key={i} style={{ marginBottom: "1rem" }}>
            <div style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>
              
            </div>
            <TablesContainer
                goToRef={goToRef}
                array={examen.resultados}
                results_comment={examen.comentarioHTML ? 
                  examen.comentarioHTML.map(c => ({
                    posicion: c.posicion,
                    comentario: c.HTML
                  })) : []
                }
                patientHistoric={this.props.patientHistoric}
                selectedPatientID={this.props.selectedPatientID}
                uniqES6={this.uniqES6}
            />
            <Divider />
          </div>
        ))}
      </div>
    ));

    const microSection = (
      <>
      <div>
        {/*<div style={styles.segment}>MICROBIOLOGIA GENERAL</div>*/}
        {tablas}
      </div>
      </>
    );

    const comment200 = this.props.order.results_comments.filter(
      c => Number(c.posicion) === 200
    )
    showComments = comment200.length > 0;

    const comment200Section = (
      <div>
        <div style={styles.segment}>COMENTARIOS</div>
        <Container>
          {comment200.map((c,idx) => (
            <div key={idx} style={{ 
            color:'gray', 
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            fontSize:'12px'
          }} dangerouslySetInnerHTML={{
                __html: c.HTML
            }}>
            </div>
          ))}
        </Container>
      </div>
    )

    if (maxNroMuestras > 0) {
      showMicro = true;
    } else {
      showMicro = false;
    }
    return (
      <div>
        {showResults ? sections : null}
        {showComments ? comment200Section : null}
        {showMicro ? microSection : null}
      </div>
    );
  }
}

const styles = {
  segment: {
    textAlign: "center",
    fontSize: "16px",
    color: "black",
    position: "relative",
    background: "#fff",
    margin: "1rem 0 1rem 0",
    padding: "1em 1em",
    borderRadius: "0.28571429rem",
    border: "2px solid #00ACC9",
    //backgroundColor: "#00ACC9",
    boxShadow: "0 1px 2px 0 rgba(34, 36, 38, 0.15)"
  }
};

Results.propTypes = {
  order: PropTypes.shape({
    orderNumber: PropTypes.string,
    physician: PropTypes.string,
    service: PropTypes.string,
    insurance: PropTypes.string,
    historyNumber: PropTypes.string,
    phone: PropTypes.string,
    office: PropTypes.string,
    bed: PropTypes.string
  }).isRequired,
  patientHistoric: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    order: state.patientOrderResults.order
  };
}

export default connect(
  mapStateToProps,
  { patientHistoric }
)(Results);
